import styled from 'styled-components'
import { theme } from '@dasa-health/components-react'

export const Text = styled.p`
    color: #666;
`

export const Illustrator = styled.img`
    display: none;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        display: flex;
        justify-self: center;
    }
`
